export default __webpack_public_path__ + "2813281.png";